import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { formatDate } from '../../utils';
export const FormatDate = ({ date, outputFormat, inputFormat, locale }) => {
    return _jsx(_Fragment, { children: formatDate(date, outputFormat, inputFormat, locale) });
};
